import { useState } from "react";
import { Stack, IconButton, Box } from "@mui/material";
import { useForm } from "react-hook-form";
import InputText from "@/components/form/InputText";
import { Search } from "@mui/icons-material";
import { SearchQuestionnaire } from "./components/SearchQuestionnaire";

interface FiltersQuestionnaireProps {
    searchTerm: string;
    setSearchTerm: (searchTerm: string) => void;
    selectedStatus: string;
    setSelectedStatus: (selectedStatus: string) => void;
    anchorEl: HTMLElement | null;
    setAnchorEl: (anchorEl: HTMLElement | null) => void;
    responseFilter?: string;
    setResponseFilter?: (filter: string) => void;
}

export function FiltersQuestionnaire({ searchTerm, setSearchTerm, selectedStatus, setSelectedStatus, anchorEl, setAnchorEl, responseFilter, setResponseFilter }: FiltersQuestionnaireProps) {

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center" px={4} gap={2}>
            <SearchQuestionnaire searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            {/* Botão de filtro por status */}
            {/* <Box display="flex" alignItems="center" gap={1}>
                <Button
                    variant="outlined"
                    startIcon={<FilterList />}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    size="small"
                >
                    Filtrar
                </Button>
                {selectedStatus && (
                    <Chip
                        label={statusQuestionnaire(selectedStatus)}
                        color={getStatusColor(selectedStatus) as any}
                        onDelete={() => setSelectedStatus("")}
                        size="small"
                    />
                )}
                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                >
                    <Box p={2} minWidth={180}>
                        <Typography variant="subtitle2" gutterBottom>
                            Status
                        </Typography>
                        <Stack spacing={1}>
                            {["active", "draft", "retired", "unknown"].map((status) => (
                                <MenuItem
                                    key={status}
                                    selected={selectedStatus === status}
                                    onClick={() => {
                                        setSelectedStatus(status);
                                        setAnchorEl(null);
                                    }}
                                >
                                    <Box display="flex" alignItems="center" gap={1}>
                                        {StatusIcon(status)}
                                        <Typography variant="body2">
                                            {statusQuestionnaire(status)}
                                        </Typography>
                                    </Box>
                                </MenuItem>
                            ))}
                            <MenuItem
                                onClick={() => {
                                    setSelectedStatus("");
                                    setAnchorEl(null);
                                }}
                                selected={selectedStatus === ""}
                            >
                                <Typography variant="body2" color="text.secondary">
                                    Limpar filtro
                                </Typography>
                            </MenuItem>
                        </Stack>
                        
                        {setResponseFilter && (
                            <>
                                <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
                                    Status de Resposta
                                </Typography>
                                <Stack spacing={1}>
                                    <MenuItem
                                        selected={responseFilter === "responded"}
                                        onClick={() => {
                                            setResponseFilter("responded");
                                            setAnchorEl(null);
                                        }}
                                    >
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <CheckCircle sx={{ color: "success.main", fontSize: 16 }} />
                                            <Typography variant="body2">
                                                Respondidos
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                    <MenuItem
                                        selected={responseFilter === "not-responded"}
                                        onClick={() => {
                                            setResponseFilter("not-responded");
                                            setAnchorEl(null);
                                        }}
                                    >
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <RadioButtonUnchecked sx={{ color: "warning.main", fontSize: 16 }} />
                                            <Typography variant="body2">
                                                Não respondidos
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                    <MenuItem
                                        selected={responseFilter === ""}
                                        onClick={() => {
                                            setResponseFilter("");
                                            setAnchorEl(null);
                                        }}
                                    >
                                        <Typography variant="body2" color="text.secondary">
                                            Todos
                                        </Typography>
                                    </MenuItem>
                                </Stack>
                            </>
                        )}
                    </Box>
                </Popover>
            </Box> */}
        </Stack>
    );
}
